import { useSentryQuery, useSentryMutation } from '../utils/sentryQueryWrapper';
import {
  createPickupAddress,
  deletePickupAddress,
  fetchPickupAddressByUID,
  fetchPickupAddresses,
  fetchPickupLastCod,
  updatePickupAddress,
} from '@/api';
import {
  ErrorMessageResponse,
  PickupAddressResponse,
  PickupFetchAddressResponse,
  SinglePickupResponse,
  PickupRequest,
  SinglePickupAddressResponse,
  UpdatePickupParams,
} from '@/types';

// Fetch all pickup addresses
export const useFetchPickupAddresses = (page?: number) => {
  return useSentryQuery<PickupFetchAddressResponse, Error>(
    ['pickupAddresses', page],
    () => fetchPickupAddresses(page),
    {
      keepPreviousData: true,
    },
  );
};

// Fetch Last Cod Pickup Address
export const useFetchPickupLastCod = () => {
  return useSentryQuery<SinglePickupResponse, Error>(['lastCod'], () => fetchPickupLastCod());
};

// Fetch a single pickup address by UID
export const useFetchPickupAddressByUID = (uid: string, enabled: boolean = true) => {
  return useSentryQuery<SinglePickupAddressResponse, Error>(
    ['pickupAddress', uid],
    () => fetchPickupAddressByUID(uid),
    {
      enabled: !!uid && enabled,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: 'always',
    },
  );
};

// Create a new pickup address
export const useCreatePickupAddress = () => {
  return useSentryMutation<SinglePickupResponse, ErrorMessageResponse, PickupRequest>(
    (data: PickupRequest) => createPickupAddress(data),
  );
};

// Update an existing pickup address
export const useUpdatePickupAddress = () => {
  return useSentryMutation<SinglePickupResponse, ErrorMessageResponse, UpdatePickupParams>(
    ({ data, uid }: UpdatePickupParams) => updatePickupAddress(data, uid),
  );
};

// Delete a pickup address by UID
export const useDeletePickupAddress = () => {
  return useSentryMutation<void, Error, string>((uid: string) => deletePickupAddress(uid));
};
